import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 440px;
`;
export const FormTitle = styled.span.attrs({ className: 'hl3' })`
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const FormSubTitle = styled.span.attrs({ className: 'body_text' })`
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const FormLine = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
`;

export const FormLineTitle = styled.span`
  font-weight: 600;
  width: 120px;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.baseBlue.a10};
  flex-shrink: 0;
`;

export const FieldWrapper = styled.div`
  flex: 1;
  margin-left: 15px;
`;
